import { useEffect, useState } from "react";
import { MyBookingUpCommingWidgetStyled } from "./styled";
import { userService } from "apiServices";
import moment from "moment";
import { Cards } from "components";

// autoOpenPaymentBookingId: มาจากลิงก์อีเมล (?booking_id=) ให้การ์ดใบนั้นเปิด popup แจ้งชำระเงินเอง
const MyBookingUpCommingWidget = ({
  room_type,
  autoOpenPaymentBookingId,
  onAutoOpenedPayment,
}) => {
  const [_data, _setData] = useState();

  useEffect(() => {
    _fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const _fetchData = async () => {
    console.log("room_type", room_type);
    let res = await userService.GET_ROOM_BOOKING_MY_UPCOMING_LIST(
      `?booking_start_date=${moment().format(
        "YYYY-MM-DD"
      )}&booking_end_date=${moment()
        .add(6, "month")
        .format("YYYY-MM-DD")}&room_type=${room_type}&limit=100`
    );
    if (res && res.status === 200) {
      _setData({ ...res.data, docs: _sortBookings(res.data.docs) });
    }
  };

  // ล่าสุดอยู่บนสุด และรายการที่จองสำเร็จ (status 5) อยู่ด้านล่าง
  const _sortBookings = (docs = []) =>
    [...docs].sort((a, b) => {
      const aSuccess = a.status === "5" ? 1 : 0;
      const bSuccess = b.status === "5" ? 1 : 0;
      if (aSuccess !== bSuccess) {
        return aSuccess - bSuccess;
      }
      return moment(b.created_at).valueOf() - moment(a.created_at).valueOf();
    });

  return (
    <MyBookingUpCommingWidgetStyled>
      {_data &&
        _data.docs.length > 0 &&
        _data.docs.map((e) => (
          // key ต้องเป็น _id ไม่ใช่ index เพราะรีเฟรชหลังอัปสลิปแล้วลำดับอาจเปลี่ยน popup จะไปค้างการ์ดใบอื่น
          <div key={e._id} className="booking_item">
            {/* แจ้งการชำระเงินย้ายไปเป็นปุ่ม + popup ในการ์ด */}
            <Cards.BookingSkechedule
              {...e}
              isAutoOpenPayment={
                !!autoOpenPaymentBookingId && e._id === autoOpenPaymentBookingId
              }
              onAutoOpenedPayment={onAutoOpenedPayment}
              onSuccess={_fetchData}
            />
          </div>
        ))}
    </MyBookingUpCommingWidgetStyled>
  );
};

export default MyBookingUpCommingWidget;
